import { validationRules } from "./validation_rules";

export function addNavProceedCheck(targets){
    for(const target of targets)
    {
        target.targets = targets;
        if(target.parentNode.parentNode.classList.contains("vdp-datepicker")){
            target.addEventListener("keydown", (e) => {
                updateNavProceed(e.target.targets);
            });
        }
        if(target.type==="radio"){
            document.getElementsByName(target.name)[0].addEventListener("change", (e) => {
                updateNavProceed(e.target.targets);
            });
            document.getElementsByName(target.name)[1].addEventListener("change", (e) => {
                document.getElementsByName(target.name)[1].targets=targets;
                updateNavProceed(e.target.targets);
            });
        }
        else {
            target.addEventListener("change", (e) => {
                updateNavProceed(e.target.targets);
            });
        }
        updateNavProceed(targets);
    }
}

export function updateNavProceed(targets) {
    document.getElementById('nav_next').style.display="block";
    document.getElementById('nav_previous').style.display="block";
    let oneEmpty=false;
    for(const target of targets){
        if (target.offsetWidth > 0){  
            if(target.tagName==="INPUT"&&(target.type==="radio"||target.type==='checkbox')){
                if(target.checked === false) {
                    const rules = validationRules();
                    if (!(rules[target.id]["oneofgroup"]&&document.getElementsByName(target.name)[1].checked)) {
                        oneEmpty=true;
                    }
                }
            }
            else if(target.tagName==="INPUT"){
                if(target.value ==="") oneEmpty=true;
            }
            else if(target.tagName==="SELECT"){
                if(target.options[target.selectedIndex].value==="") oneEmpty=true;
            }
        }
    }
    if(oneEmpty===false) {
        document.getElementById('nav_next_enabled').classList.remove('d-none');
        document.getElementById('nav_next_disabled').classList.add('d-none');
    }
    else {
        document.getElementById('nav_next_enabled').classList.add('d-none');
        document.getElementById('nav_next_disabled').classList.remove('d-none');
    }
  }